import React, { Component, ReactDOM } from 'react';
import {
  Card,
  CardBody,
  CardFooter,
  CardHeader,
  CardTitle,
  Col,
  Row,
  ListGroupItem,
  ListGroup
} from 'reactstrap';
import Iframe from 'react-iframe';


import MyTask from '../../components/MyTask/MyTask';
import Announcement from '../../components/Announcement/Announcement';
import ToDo from '../../components/ToDo/ToDo';
import RecentActivity from '../RecentActivities/recentActivities';
import AxiosInstance from '../../components/AxiosInstance/AxiosInstance';
import queryString from 'query-string';
var CryptoJS = require("crypto-js");

class Dashboard extends Component {
  constructor(props) {
    super(props);

    let url = this.props.location.search;
    let params = queryString.parse(url);

    this.toggle = this.toggle.bind(this);
    this.onRadioBtnClick = this.onRadioBtnClick.bind(this);

    this.state = {
      dropdownOpen: false,
      radioSelected: 2,
      tbSYSmUserID: 0,
      sectionID: params.sectionID == undefined ? 0 : params.sectionID,
      iframe_url: null
    };

    this.getUserID = this.getUserID.bind(this);
    this.LoadMyTasks = this.LoadMyTasks.bind(this);
    this.getUserID();
  }

  toggle() {
    this.setState({
      dropdownOpen: !this.state.dropdownOpen,
    });
  }

  onRadioBtnClick(radioSelected) {
    this.setState({
      radioSelected: radioSelected,
    });
  }

  getUserID() {
    AxiosInstance({
      method: 'post',
      url: 'tbSYS_m_User/GetUserID',
    })
      .then((response) => {

        var tbSYSmUserID = response.data;
        var ceil_tbSYSmUserID = parseInt(tbSYSmUserID);
        var querystring = ceil_tbSYSmUserID + "&0";
        
        var key = CryptoJS.enc.Utf8.parse('7061737323313233'); // Must be 16 character
        var iv = CryptoJS.enc.Utf8.parse('7061737323313233'); // Must be 16 character
        var encrypted = CryptoJS.AES.encrypt(CryptoJS.enc.Utf8.parse(querystring), key,
          {
            keySize: 128 / 8,
            iv: iv,
            mode: CryptoJS.mode.CBC,
            padding: CryptoJS.pad.Pkcs7
          });

        var encoded_url = encodeURIComponent(encrypted);
        
        var iframe_url = process.env.REACT_APP_STIMULSOFT_URL + '/Dashboard/MyTasks?encrypted_data=' + encoded_url;

        this.setState({
          tbSYSmUserID: response.data,
          iframe_url: iframe_url
        });
        //this.LoadMyTasks();
      })
      .catch(function (error) {
        console.log(error);
      });
  }
  
  LoadMyTasks() {

    window.Stimulsoft.Base.StiLicense.key = process.env.REACT_APP_STIMULSOFT_KEY;

    var production = process.env.REACT_APP_PRODUCTION_ENV;
    var report = window.Stimulsoft.Report.StiReport.createNewDashboard();

    if (production == "true") {
      report.loadFile(process.env.PUBLIC_URL + '/dashboardtemplates/BCMMyTasks.xml');
    } else {
      // production code
      report.loadFile(process.env.PUBLIC_URL + '/dashboardtemplates/BCMMyTasks.mrt');
    }


    var array = [];


    array.push({
      parameter: 'dctbSYSmUserID',
      value: this.state.tbSYSmUserID,
    });
    array.push({
      parameter: 'dcSectionID',
      value: this.state.sectionID,
    });


    for (var i = 0; i < report.dictionary.variables.list.length; i++) {
      var parameter = report.dictionary.variables.list[i].name;
      for (var j = 0; j < array.length; j++) {
        if (parameter == array[j].parameter) {
          report.setVariable(parameter, array[j].value);
        }
      }
    }

    //report.dictionary.databases.getByName("MS SQL").connectionString = CryptoJS.AES.encrypt(report.dictionary.databases.getByName("MS SQL").connectionString, SECRET_KEY).toString();
    //report.dictionary.dataSources.toList()[0].sqlCommand = report.dictionary.dataSources.toList()[0].sqlCommand.replace(report.dictionary.dataSources.toList()[0].name, CryptoJS.AES.encrypt(report.dictionary.dataSources.toList()[0].name, SECRET_KEY).toString());


    window.StiOptions.WebServer.url = process.env.REACT_APP_WEBSERVER_URL;

    var options = new window.Stimulsoft.Viewer.StiViewerOptions();


    var viewer = new window.Stimulsoft.Viewer.StiViewer(options, "StiViewer", false);

    viewer.report = report;

    viewer.renderHtml('viewer');
  }
  
  render() {

    return (

      <div className="animated fadeIn">
        {/*Announcement*/}
        <div >
          <Announcement />
        </div>


        <Card  >
          <CardHeader >
          </CardHeader>
          <CardBody>
            <Iframe url={ this.state.iframe_url }
              width="100%"
              height="800px"
              id="myId"
              className="myClassname"
              display="initial"
              position="relative" />

          </CardBody>
        </Card>

      </div>
    );
  }
}

export default Dashboard;



